import React, { useState } from 'react';

import {
  Box,
  Divider,
  Link,
  Typography
} from '@mui/material';

import SendInvite from '../Modal/SendInvite';

import {
  MobileArrowRightOutlineIcon
} from '../../../../../Common/components/Icons/icons';

import {
  patientInfo,
  selectedPatient
} from './data';

import {
  inviteIconSx,
  inviteLinkSx,
  inviteWrapperSx,
  metaRootSx,
  patientDividerSx,
  patientInfoContentSx,
  patientInfoItemSx,
  patientInfoLabelSx,
  patientInfoValueSx,
  patientInfoWrapperSx
} from './MetaStyles';

const Meta = () => {
  const [openInviteModal, setOpenInviteModal] = useState(false);

  const handleOpenInvite = event => {
    event.preventDefault();
    setOpenInviteModal(true);
  };

  const handleCloseInvite = () => {
    setOpenInviteModal(false);
  };

  const handleSendInvite = payload => {
    console.log('Send invitation:', payload);

    // Call your API here.

    setOpenInviteModal(false);
  };

  return (
    <>
      <Box sx={metaRootSx}>
        <Box sx={patientInfoWrapperSx}>
          {patientInfo.map((item, index) => (
            <Box
              key={item.label}
              sx={patientInfoItemSx}>
              <Box sx={patientInfoContentSx}>
                <Typography sx={patientInfoLabelSx}>
                  {item.label}
                </Typography>

                <Typography sx={patientInfoValueSx}>
                  {item.value}
                </Typography>
              </Box>

              {index !== patientInfo.length - 1 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={patientDividerSx}
                />
              )}
            </Box>
          ))}
        </Box>

        <Box sx={inviteWrapperSx}>
          <Link
            component="button"
            type="button"
            underline="always"
            color="inherit"
            onClick={handleOpenInvite}
            sx={inviteLinkSx}>
            <MobileArrowRightOutlineIcon sx={inviteIconSx} />

            Send Invitation
          </Link>
        </Box>
      </Box>

      <SendInvite
        open={openInviteModal}
        initialValue={selectedPatient}
        onClose={handleCloseInvite}
        onSubmit={handleSendInvite}
      />
    </>
  );
};

export default Meta;